import { render, staticRenderFns } from "./Varvara.vue?vue&type=template&id=7bd8b6eb"
import script from "./Varvara.vue?vue&type=script&lang=js"
export * from "./Varvara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports